import React from 'react';
import { ForceGraphConfig } from '../config/forceGraphTypes';
import { Settings, Share2, Activity, Layout } from 'lucide-react';

interface ForceGraphConfigPanelProps {
    config: ForceGraphConfig;
    onChange: (newConfig: Partial<ForceGraphConfig>) => void;
    allCols?: string[];
    chartConfig?: any;
    onChartConfigChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const ForceGraphConfigPanel: React.FC<ForceGraphConfigPanelProps> = ({
    config,
    onChange,
    allCols = [],
    chartConfig,
    onChartConfigChange
}) => {
    const handleChange = (key: keyof ForceGraphConfig, value: any) => {
        onChange({ [key]: value });
    };

    return (
        <div className="space-y-6 p-4">
            {/* Data Mapping moved to Left Sidebar */}

            {/* Layout moved to Left Sidebar */}

            <div className="h-px bg-white/10" />

            {/* Visuals Section */}
            <div className="space-y-3">
                <h4 className="text-xs font-bold text-gold-500/70 uppercase tracking-widest flex items-center gap-2">
                    <Share2 className="w-3.5 h-3.5" /> Visuals
                </h4>
                <div className="space-y-2">
                    <label className="text-xs font-medium text-gray-400">Node Radius</label>
                    <div className="flex gap-2">
                        <input
                            type="number"
                            value={config.minNodeRadius}
                            onChange={(e) => handleChange('minNodeRadius', Number(e.target.value))}
                            className="w-1/2 text-sm bg-obsidian-800 border border-white/20 rounded-lg px-2 py-1 text-gray-200"
                            placeholder="Min"
                        />
                        <input
                            type="number"
                            value={config.maxNodeRadius}
                            onChange={(e) => handleChange('maxNodeRadius', Number(e.target.value))}
                            className="w-1/2 text-sm bg-obsidian-800 border border-white/20 rounded-lg px-2 py-1 text-gray-200"
                            placeholder="Max"
                        />
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <label className="text-xs font-medium text-gray-400">Show Arrows</label>
                    <input
                        type="checkbox"
                        checked={config.showArrows}
                        onChange={(e) => handleChange('showArrows', e.target.checked)}
                        className="h-3.5 w-3.5 rounded border-white/20 bg-white/5 text-gold-500 focus:ring-gold-500"
                    />
                </div>
            </div>
        </div>
    );
};
